<template>
  <div role="alert" aria-live="polite">
    <v-expand-transition>
      <v-alert
        v-if="hasNetworkError"
        type="error"
        dismissible
        dense
        class="mb-2"
        @input="clearNetwork"
      >
        {{ networkError }}
      </v-alert>
    </v-expand-transition>
    <v-expand-transition>
      <v-alert
        v-if="hasPermissionError"
        type="warning"
        dismissible
        dense
        class="mb-2"
        @input="clearPermission"
      >
        {{ permissionError }}
      </v-alert>
    </v-expand-transition>
    <v-expand-transition>
      <v-alert
        v-if="hasGlobalError"
        type="error"
        dismissible
        dense
        class="mb-2"
        @input="clearGlobal"
      >
        {{ globalError }}
      </v-alert>
    </v-expand-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ErrorBanner',
  computed: {
    ...mapGetters('error', [
      'hasNetworkError',
      'hasPermissionError',
      'hasGlobalError',
    ]),
    networkError() {
      return this.$store.state.error.networkError
    },
    permissionError() {
      return this.$store.state.error.permissionError
    },
    globalError() {
      return this.$store.state.error.globalError
    },
  },
  methods: {
    clearNetwork() {
      this.$store.commit('error/clearNetworkError')
    },
    clearPermission() {
      this.$store.commit('error/clearPermissionError')
    },
    clearGlobal() {
      this.$store.commit('error/clearAllErrors')
    },
  },
}
</script>
